import React from 'react';
import './templateParametro.css';
import IcMais from '../../../../../assets/img/ic_mais.svg';
import { Button } from '@company-mrv/mrv-design-system/components';
import EnviarEventGrid from './enviarEventGrid/enviarEventGrid';
import ModalComBotaoFechar from '../../../../../lib/components/modalComBotaoFechar/modalComBotaoFechar';
import MensagemModal from '../../../../../lib/components/mensagemModal/mensagemModal';
import FileSaver from 'file-saver';

class TemplateParametro extends React.Component<
{
    enviarParametrosEventGrid: Function,
    baixarExcelParametros: Function,
    enviarExcelParametros: Function,
    deletarExcelParametros: Function,
    nomeDoArquivo: string
}, 
{
    file: any,
    sucessoEnviarArquivo: boolean,
    falhaEnviarArquivo: boolean,
    sucessoDeletarArquivo: boolean,
    falhaDeletarArquivo: boolean,
    mensagemErro: string,
    avisoEnviarArquivo: string,
    loadingEnviarArquivo: boolean,
    loadingDeletarArquivo: boolean,
    loadingBaixarArquivo: boolean
}> {
    constructor(props: any)
    {
        super(props);
        this.state =
        {
            file: '',
            sucessoEnviarArquivo: false,
            falhaEnviarArquivo: false,
            sucessoDeletarArquivo: false,
            falhaDeletarArquivo: false,
            mensagemErro: '',
            avisoEnviarArquivo: '',
            loadingEnviarArquivo: false,
            loadingDeletarArquivo: false,
            loadingBaixarArquivo: false,
        };

        this.limparMensagensSucessoErro = this.limparMensagensSucessoErro.bind(this);
        this.possuiMensagemRetorno = this.possuiMensagemRetorno.bind(this);
    }

    setFile(e: any)
    {
        this.setState({
            file: e.target.files[0],
            sucessoEnviarArquivo: false,
            falhaEnviarArquivo: false,
            sucessoDeletarArquivo: false,
            falhaDeletarArquivo: false,
            avisoEnviarArquivo: ''
        });
    }

    clearFile(e: any)
    {
        e.target.value = null
        this.setState({
            file: '',
            sucessoEnviarArquivo: false,
            falhaEnviarArquivo: false,
            sucessoDeletarArquivo: false,
            falhaDeletarArquivo: false,
            avisoEnviarArquivo: ''
        });
    }

    limparMensagensSucessoErro(): void
    {
        this.setState({
            sucessoEnviarArquivo: false,
            falhaEnviarArquivo: false,
            sucessoDeletarArquivo: false,
            falhaDeletarArquivo: false,
            avisoEnviarArquivo: ''
        });
    }

    possuiMensagemRetorno(): boolean 
    {
        return this.state.sucessoEnviarArquivo ||
            this.state.falhaEnviarArquivo ||
            this.state.sucessoDeletarArquivo ||
            this.state.falhaDeletarArquivo;
    }

    obterMensagemErro(err: any): string
    {
        const mensagemServidor = err?.response?.data?.message;
        if (mensagemServidor) return mensagemServidor;

        const correlationId = err?.correlationId ?? 'desconhecido';
        return `Falha técnica ao processar sua solicitação — não houve resposta do servidor. Contate o suporte informando o código ${correlationId}.`;
    }

    delete = async (e: any) =>
    {
        e.preventDefault();
        this.setState({ loadingDeletarArquivo: true});

        this.props.deletarExcelParametros(this.state.file)
            .then(() =>
            {
                this.setState({
                    sucessoDeletarArquivo: true,
                    falhaDeletarArquivo: false,
                    file: '',
                    loadingDeletarArquivo: false
                });
            })
            .catch((err: any) =>
            {
                this.setState({
                    sucessoDeletarArquivo: false,
                    falhaDeletarArquivo: true,
                    mensagemErro: this.obterMensagemErro(err),
                    loadingDeletarArquivo: false
                });
            });
    }

    submit = async (e: any) =>
    {
        e.preventDefault();
        this.setState({ loadingEnviarArquivo: true });

        this.props.enviarExcelParametros(this.state.file)
            .then((res: any) =>
            {
                const publicacaoFalhou = res?.data?.PublicacaoConcluida === false;
                this.setState({
                    sucessoEnviarArquivo: true,
                    falhaEnviarArquivo: false,
                    avisoEnviarArquivo: publicacaoFalhou ? res.data.Mensagem : '',
                    file: '',
                    loadingEnviarArquivo: false
                });
            })
            .catch((err: any) =>
            {
                this.setState({
                    sucessoEnviarArquivo: false,
                    falhaEnviarArquivo: true,
                    mensagemErro: this.obterMensagemErro(err),
                    loadingEnviarArquivo: false
                });
            });
    }

    baixar = async () => 
    {
        this.setState({loadingBaixarArquivo: true});

        this.props.baixarExcelParametros()
            .then((res: any) =>
            {
                if (res)
                {
                const file = new File([res.data], `${this.props.nomeDoArquivo} - ${process.env.REACT_APP_AMBIENTE}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                FileSaver.saveAs(file);
                }

                this.setState({
                    loadingBaixarArquivo : false,
                });
            }) 
            .catch((err: any) => 
            {
                this.setState({
                    loadingBaixarArquivo : false,
                });
            });
    }
    

    render() 
    {
        const { enviarParametrosEventGrid } = this.props;

        return (
            <div className="container-parametro">
                <form className="form-input-arquivo" onSubmit={e => this.submit(e)}>
                    <label className="input-arquivo">
                        <div></div>
                        <input type="file" onClick={e => this.clearFile(e)} onChange={e => this.setFile(e)} />
                        {' '}Upload de arquivo
                        <img src={IcMais} alt="Logotipo da MRV" />
                    </label>
                    <span className="nome-arquivo">{this.state.file?.name}</span>
                    <div className="barra-arquivo">
                        <div className='enviar-arquivo'><Button loading={this.state.loadingEnviarArquivo} size="small" type="submit" disabled={!this.state.file}>Enviar</Button></div>
                        <div className='deletar-arquivo'><Button onClick={e => this.delete(e)} loading={this.state.loadingDeletarArquivo} size="small" disabled={!this.state.file}>Deletar</Button></div>
                    </div>
                </form>
                <Button loading={this.state.loadingBaixarArquivo} size="small" variant="ghost" className="botao baixar-arquivo" onClick={this.baixar}>Baixar Arquivo</Button>
                <EnviarEventGrid  enviarParametrosEventGrid={enviarParametrosEventGrid}/>
                <ModalComBotaoFechar
                    isOpen={this.possuiMensagemRetorno()}
                    onRequestClose={this.limparMensagensSucessoErro}
                    aoClicarBotaoFecharModal={this.limparMensagensSucessoErro}>
                        {this.state.sucessoDeletarArquivo && <MensagemModal mensagem="Parâmetro(s) deletado(s) com sucesso"></MensagemModal>}
                        {this.state.sucessoEnviarArquivo && !this.state.avisoEnviarArquivo && <MensagemModal mensagem="Arquivo cadastrado com sucesso"></MensagemModal>}
                        {this.state.sucessoEnviarArquivo && this.state.avisoEnviarArquivo && <MensagemModal mensagem={this.state.avisoEnviarArquivo} aviso={true}></MensagemModal>}
                        {this.state.falhaEnviarArquivo && <MensagemModal mensagem={this.state.mensagemErro} erro={true}></MensagemModal>}
                        {this.state.falhaDeletarArquivo && <MensagemModal mensagem={this.state.mensagemErro} erro={true}></MensagemModal>}
                </ModalComBotaoFechar>
            </div>
        );
    }
}

export default TemplateParametro